import { useQuery } from '@tanstack/react-query';
import { useSession } from '@/hooks/useSession';
import { getWmsUsers } from '../api';
import type { WmsUserFilters } from '../types';

// Query keys
export const wmsUsersKeys = {
  all: ['wms-users'] as const,
  list: (orgId: string, filters?: WmsUserFilters) => [...wmsUsersKeys.all, 'list', orgId, filters] as const,
};

// ============================================================================
// Users Query Hooks
// ============================================================================

export function useWmsUsers(filters: WmsUserFilters = {}) {
  const { user } = useSession();
  const organizationId = user?.organisation;

  return useQuery({
    queryKey: wmsUsersKeys.list(organizationId || '', filters),
    queryFn: () => getWmsUsers(organizationId!, filters),
    enabled: !!organizationId,
  });
}

export function useWmsUserSearch(search: string, enabled: boolean = true) {
  const { user } = useSession();
  const organizationId = user?.organisation;

  return useQuery({
    queryKey: wmsUsersKeys.list(organizationId || '', { search, enabled: true, page_length: 20 }),
    queryFn: () => getWmsUsers(organizationId!, { search, enabled: true, page_length: 20 }),
    enabled: !!organizationId && enabled && search.length >= 1,
  });
}
